<template>
  <div>
    <Loader :loading='loading' />
    <div class="home container-fluid" v-if="!loading">
      <div class='row mt-3'>
        <div class="col">
          <h1 class="title-1">Genre "{{ genre }}"</h1>
        </div>
        <div class="col text-right">
          <SortDropdown :onChange='sortItem' :active='$route.query.sort' />
        </div>
      </div>
      <div class="alert alert-secondary alert-dark mt-3" v-if="totalCount < 1">
        <span>Sorry! no record found for your query</span>
      </div>
      <div class="row">
        <FilmGrid v-for="movie in movies" v-bind:key="movie.id"
          :id='movie.id'
          :url="(movie.type == 'article' ? '/movie/' : '/tv-show/') + movie.id" 
          :avatar='movie.avatar'
          :played="movie.is_played"
          :favorite="movie.is_favorite"
          :secondaryTitle='movie.secondary_title'
          :title="movie.title"
          :year="movie.year"
          :rate='movie.rating'
          :type='movie.type'
          :watchlater='movie.watch_later_count'
        />
      </div>

      <div class="row">
        <div class="col-12 text-center">
          <el-pagination
            v-if="totalCount"
            @current-change="handleSizeChange"
            background
            layout="prev, pager, next"
            :current-page="currentPage"
            :page-size="perPageItem"
            :total="totalCount"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import FilmGrid from "../components/FilmGrid";
import SortDropdown from "../components/SortDropdown";
import Loader from "../components/Loader";
import {  authRequest } from '../app/helpers';

export default {
  data() {
    return {
      loading: true,
      movies: [],
      totalCount: 0,
      currentPage: null,
      perPageItem: 0,
      page: '',
      sort: '',
      genre: '',
    }
  },
  components: {
    FilmGrid,
    Loader,
    SortDropdown,
  },
  name: "home",
  methods: {
    async fetchMovies() {
      this.loading = true;
      const query = `page=${this.page}&sort=${this.sort}&genre=${this.genre}`;
      const request = await authRequest(this.$router, '/search?' + query);

      this.loading = request ? false : true;
      this.movies = request.results;
      this.currentPage = request.currentPage
      this.totalCount = request.totalItems
      this.perPageItem = request.limit
    },

    handleSizeChange(page) {
      this.loading = true;
      let params = this.$route.query;
      params = {...params, page}
      
      this.$router.push({
        query: params
      })
    },

    sortItem(sort) {
      const query = {...this.$route.query, sort};

      this.$router.push({ query });
    },

    setQuery() {
      const route = this.$route;
      this.sort = route.query.sort || '';
      this.genre = route.params.genre || '';
      this.page = route.query.page || 1;
    },

  },
  mounted() {
    this.$store.commit('bodyClass', 'movies-list genre-page');
    this.setQuery();
    this.fetchMovies();
  },
  watch: {
    $route () {
      this.setQuery();
      this.fetchMovies();
    }
  }
};
</script>
